import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  container({ packing_house_process_id, container_id }) {
    return RequesterV1.get(
      `packing_house/production/uniq_final_packing_list/upload_packing_list/${packing_house_process_id}/container/${container_id}`
    );
  },
  fetchPackingHouseProcess({ packing_house_process_id }) {
    return RequesterV1.get(
      "packing_house/production/uniq_final_packing_list/upload_packing_list/${packing_house_process_id}/fetch_packing_house_process/" +
        packing_house_process_id
    );
  },
  uploadVerticalPackingList(packing_house_process_id, container_id, file) {
    return RequesterV1.post(
      `packing_house/production/uniq_final_packing_list/upload_packing_list/${packing_house_process_id}/upload_vertical/${container_id}`,
      file
    );
  },
  uploadHorizontalPackingList(packing_house_process_id, container_id, file) {
    return RequesterV1.post(
      `packing_house/production/uniq_final_packing_list/upload_packing_list/${packing_house_process_id}/upload_horizontal/${container_id}`,
      file
    );
  },
  downloadHorizontalFormatXlsx(packing_house_process_id, container_id) {
    return RequesterV1.get(
      `packing_house/production/uniq_final_packing_list/upload_packing_list/${packing_house_process_id}/download_horizontal_format_xlsx/${container_id}`,
      { responseType: "blob" }
    );
  },
  downloadVerticalFormatXlsx(packing_house_process_id, container_id) {
    return RequesterV1.get(
      `packing_house/production/uniq_final_packing_list/upload_packing_list/${packing_house_process_id}/download_vertical_format_xlsx/${container_id}`,
      { responseType: "blob" }
    );
  },
  fetchVerticalFormatHeaders(packing_house_process_id, container_id) {
    return RequesterV1.get(
      `packing_house/production/uniq_final_packing_list/upload_packing_list/${packing_house_process_id}/fetch_vertical_format_headers/${container_id}`
    );
  },
  fetchHorizontalFormatHeaders(packing_house_process_id, container_id) {
    return RequesterV1.get(
      `packing_house/production/uniq_final_packing_list/upload_packing_list/${packing_house_process_id}/fetch_horizontal_format_headers/${container_id}`
    );
  }
};
